import createIcon from '../../createIcon';

/**
 * @component @name GridOn
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMkg0QzIuOSAyIDIgMi45IDIgNFYyMEMyIDIxLjEgMi45IDIyIDQgMjJIMjBDMjEuMSAyMiAyMiAyMS4xIDIyIDIwVjRDMjIgMi45IDIxLjEgMiAyMCAyWk04IDIwSDRWMTZIOFYyMFpNOCAxNEg0VjEwSDhWMTRaTTggOEg0VjRIOFY4Wk0xNCAyMEgxMFYxNkgxNFYyMFpNMTQgMTRIMTBWMTBIMTRWMTRaTTE0IDhIMTBWNEgxNFY4Wk0yMCAyMEgxNlYxNkgyMFYyMFpNMjAgMTRIMTZWMTBIMjBWMTRaTTIwIDhIMTZWNEgyMFY4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GridOn = createIcon('GridOn', [
  [
    'path',
    {
      d: 'M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM8 20H4V16H8V20ZM8 14H4V10H8V14ZM8 8H4V4H8V8ZM14 20H10V16H14V20ZM14 14H10V10H14V14ZM14 8H10V4H14V8ZM20 20H16V16H20V20ZM20 14H16V10H20V14ZM20 8H16V4H20V8Z',
      key: '11oqc4',
    },
  ],
]);

export default GridOn;
